<template>
  <div>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        <div class="d-flex flex-column">
          <strong>وبکارت</strong>
          <small class="text-muted text-small">پرسنل قسمت</small>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div id="viewer" dir="ltr"></div>
  </div>
</template>

<script>
import reportFile from "../../assets/reports/personelsList.mrt";
import reportTexts from "../../assets/js/reports";
import EosUtils from "../../utils/EosUtils";
import ResultType from "../../model/ResultType";

export default {
  data() {
    return {
      visible: false,
      dataLoaded: false,
      variables: null,
      list: null,
    };
  },
  mounted() {
    this.loadPage();
  },
  watch: {
    dataLoaded(newVal) {
      if (newVal) {
        this.showReport();
      }
    },
  },
  methods: {
    loadPage() {
      var args = this.$route.query;
      var perno = this.$store.state.auth.auth.username;
      var sectionCode = args.SC;

      this.ValidateQueryInputs(perno, sectionCode);
      this.getData(perno, sectionCode);
    },
    ValidateQueryInputs(perno, sectionCode) {
      if (!perno) {
        this.transferPage();
      }
      if (!sectionCode) {
        this.transferPage();
      }
    },
    transferPage() {
      //todo : error wrong page
    },
    async getData(perno, sectionCode) {
      var moment = require("jalali-moment");

      var variables = {};
      if (EosUtils.isWebKartAdmin()) {
        variables.perno = "-";
        variables.personName = "مدير وب کارت";
      } else {
        variables.perno = perno;
        variables.personName =
          this.$store.state.personel.personelDetail.PersonName;
      }

      variables.timeNow = moment().locale("fa").format("YYYY/MM/DD HH:mm");
      var GetCustomerNameResponse = await this.$store.dispatch(
        "lock/GetCustomerName"
      );
      if (GetCustomerNameResponse.type == ResultType.success) {
        variables.companyName = GetCustomerNameResponse.data;
      }

      if (sectionCode == "0" || sectionCode == "" || sectionCode == "-1") {
        //sectionCode = "";
        variables.sectionCode = "-";
        variables.sectionName = "تمام قسمت ها";
      } else {
        variables.sectionCode = sectionCode;
        variables.sectionName = "";

        var findSectionNameResponse = await this.$store.dispatch(
          "sections/findSectionName",
          {
            data: {
              sectionCode: sectionCode,
            },
          }
        );
        if (findSectionNameResponse.type == ResultType.success) {
          variables.sectionName = findSectionNameResponse.data;
        }
      }

      this.variables = variables;

      this.$store
        .dispatch("GetSectionPersons", {
          params: {
            sectionCode: sectionCode,
          },
        })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            this.list = result.data.Table1;
            this.dataLoaded = true;
          }
        });
    },
    showReport() {
      window.Stimulsoft.Base.StiLicense.key = reportTexts.getStimulKey();
      let options = new window.Stimulsoft.Viewer.StiViewerOptions();
      /*options.appearance.fullScreenMode = true;
      options.toolbar.displayMode =
        window.Stimulsoft.Viewer.StiToolbarDisplayMode.Separated;*/
      var viewer = new window.Stimulsoft.Viewer.StiViewer(
        options,
        "StiViewer",
        false
      );

      let report = window.Stimulsoft.Report.StiReport.createNewReport();
      report.load(reportFile);

      report.dictionary.variables.getByName("CompanyName").valueObject =
        this.variables.companyName;

      report.dictionary.variables.getByName("ReportDate").valueObject =
        this.variables.timeNow;
      report.dictionary.variables.getByName("Perno").valueObject =
        this.variables.perno;
      report.dictionary.variables.getByName("PersonName").valueObject =
        this.variables.personName;
        report.dictionary.variables.getByName("sectionCode").valueObject =
        this.variables.sectionCode;
      report.dictionary.variables.getByName("sectionName").valueObject =
        this.variables.sectionName;

      report.regData("d1", "d1", this.list);

      viewer.report = report;
      viewer.renderHtml("viewer");
    },
  },
};
</script>

<style>
</style>